import type { Merchant } from "@unbox/api";
import type React from "react";
import { createContext, useContext } from "react";
import { useMe } from "@/api/me";

interface PortfolioContextType {
  enabled: boolean;
  merchants: Merchant[];
}

const PortfolioContext = createContext<PortfolioContextType | undefined>(undefined);

export const PortfolioProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const { data: user } = useMe();

  const directMerchants = user?.merchants ?? [];
  const workspaceMerchants = user?.workspaces?.flatMap((w) => w.merchants) ?? [];
  const seen = new Set<string>();
  const merchants = [...directMerchants, ...workspaceMerchants].filter((m) => {
    if (seen.has(m.id)) return false;
    seen.add(m.id);
    return true;
  });
  const enabled = merchants.length > 1;

  return <PortfolioContext.Provider value={{ enabled, merchants }}>{children}</PortfolioContext.Provider>;
};

export const usePortfolio = () => {
  const ctx = useContext(PortfolioContext);
  if (!ctx) throw new Error("usePortfolio must be used within PortfolioProvider");
  return ctx;
};
